import React from 'react';

import {
  DEFAULT_BACKGROUND,
  backgroundTemplateMappings,
} from '../../backgroundSettings/BackgroundSettings';

interface CenterPanelProps {
  children: React.ReactNode;
}

export const CenterPanel: React.FC<CenterPanelProps> = ({ children }) => {
  const defaultBackgroundImage =
    backgroundTemplateMappings[DEFAULT_BACKGROUND.value];

  return (
    <div
      className="tw-min-h-screen tw-w-full tw-bg-center tw-bg-no-repeat tw-bg-cover tw-flex tw-justify-center tw-items-center tw-p-8"
      style={{ backgroundImage: `url(${defaultBackgroundImage})` }}
    >
      {children}
    </div>
  );
};
